export const k = {
    dialogHeader: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.preview-dialog.preview-dialog-i18n.dialogHeader"
};
export const translations = {
    da: { dialogHeader: "Faktura preview" },
    en: {
        dialogHeader: "Invoice preview"
    }
};
